import { handleActions } from 'redux-actions';
import { getParameterFromString } from '../../../../app/utils/getParameter';
import { magentoActions } from '../../actions/magentoCards';
export const { getMagentoCardById, getMagentoCardByIdSucceeded, getMagentoCardByIdFailed, getMagentoCards, getMagentoCardsSucceeded, getMagentoCardsFailed, getMagentoCard, testMagentoCard, testMagentoCardSucceeded, testMagentoCardFailed, editMagentoCard, editMagentoCardSucceeded, editMagentoCardFailed, removeMagentoCard, removeMagentoCardSucceeded, removeMagentoCardFailed, addMagentoCard, addMagentoCardSucceeded, addMagentoCardFailed, resetMagentoCard, } = magentoActions;
export function emptyCard() {
    return {
        card_type: 'magento',
        hook: {
            title: '',
            hook_id: '',
            apikey: '',
            magentoSubdomain: '',
            headers: null,
            uri_template: '',
            created_at: '',
            card_version: '',
        },
        template: '',
    };
}
function parseURLParameters(url) {
    return {
        apikey: getParameterFromString('apikey', url),
        magentoSubdomain: getParameterFromString('api_hostname', url),
    };
}
const initialState = {
    cards: [],
    currentCard: emptyCard(),
    testResult: null,
    meta: null,
};
// Reducer
export const magentoCards = handleActions({
    [getMagentoCards.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getCardsAsyncStatus: 'loading' }) });
    },
    [getMagentoCardsSucceeded.toString()]: (state, action) => {
        const cards = action.payload.data.custom_cards.filter((magentoCard) => magentoCard.card_type === 'magento');
        cards.forEach((card) => {
            card.hook = Object.assign(Object.assign({}, card.hook), parseURLParameters(card.hook.uri_template));
        });
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getCardsAsyncStatus: 'succeeded' }), cards });
    },
    [getMagentoCardsFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getCardsAsyncStatus: 'failed' }) });
    },
    [getMagentoCard.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign({}, state.meta), currentCard: action.payload });
    },
    [getMagentoCardById.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getCardByIdAsyncStatus: 'loading' }) });
    },
    [getMagentoCardByIdSucceeded.toString()]: (state, action) => {
        const card = action.payload.data;
        card.hook = Object.assign(Object.assign({}, card.hook), parseURLParameters(card.hook.uri_template));
        return Object.assign(Object.assign({}, state), { currentCard: action.payload.data, meta: Object.assign(Object.assign({}, state.meta), { getCardByIdAsyncStatus: 'succeeded' }) });
    },
    [getMagentoCardByIdFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getCardByIdAsyncStatus: 'failed' }) });
    },
    [testMagentoCard.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { testAsyncStatus: 'loading' }), testResult: null });
    },
    [testMagentoCardSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { testAsyncStatus: 'succeeded' }), testResult: Object.assign({}, action.payload.data) });
    },
    [testMagentoCardFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { testAsyncStatus: 'failed' }) });
    },
    [addMagentoCard.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { createAsyncStatus: 'loading' }) });
    },
    [addMagentoCardSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { createAsyncStatus: 'succeeded' }) });
    },
    [addMagentoCardFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { createAsyncStatus: 'failed' }) });
    },
    [removeMagentoCard.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { removeAsyncStatus: 'loading' }) });
    },
    [removeMagentoCardSucceeded.toString()]: (state, action) => {
        const cardsCopy = state.cards.slice();
        const cards = cardsCopy.filter((x) => x.hook.hook_id !== action.payload.data.hook.hook_id);
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { removeAsyncStatus: 'succeeded' }), currentCard: emptyCard(), cards: cards });
    },
    [removeMagentoCardFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { removeAsyncStatus: 'failed' }) });
    },
    [editMagentoCard.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { editAsyncStatus: 'loading' }) });
    },
    [editMagentoCardSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { editAsyncStatus: 'succeeded' }) });
    },
    [editMagentoCardFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { editAsyncStatus: 'failed' }) });
    },
    [resetMagentoCard.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { currentCard: emptyCard(), testResult: null, meta: Object.assign(Object.assign({}, state.meta), { getCardByIdAsyncStatus: null }) });
    },
}, initialState);
